import type { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import { match } from 'ts-pattern'

export interface TaskStateTextProps {
  state: StandardTask['state']
}

export function TaskStateText({ state }: TaskStateTextProps): string {
  return match(state)
    .with('todo', () => 'Not Started')
    .with('in-progress', () => 'In Progress')
    .with('done', () => 'Done')
    .with('backlog', () => 'Backlog')
    .with('canceled', () => 'Canceled')
    .with('duplicate', () => 'Duplicate')
    .exhaustive()
}
